import Node from "../Node";

/**
 * A leaf node.
 */
export default abstract class Leaf extends Node {}
